import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { NumberFormat } from "utils/HelperFunction";
import { Formik } from "formik";
import * as yup from "yup";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Form, Modal, Button } from "react-bootstrap";
import { useMediaQuery, Stack, Badge, Tooltip, Chip, Box, Popper, Grow, Paper, MenuList, MenuItem, ClickAwayListener } from "@mui/material";
import moment from "moment";
import { nanoid } from "nanoid";
import DeleteIcon from "@mui/icons-material/Delete";
import { ModalAllder } from "layouts/ModalAllder";
import LanguageIcon from "@mui/icons-material/Language";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import { useTranslation } from "react-i18next";
import { myReserver } from "../redux/handlers/catalog/myReserver.handler";
// import { myReserverList } from "../redux/handlers/catalog/myReserverList.handler";
import "styles/catalog.css";
import { useTheme } from "@mui/material";
import { Page, Text, View, Document, StyleSheet, Font, Image, pdf } from "@react-pdf/renderer";
import thsarabun from "fonts/THSarabunNew.ttf";
import thsarabunBold from "fonts/THSarabunNewBold.ttf";
import sarabun from "fonts/SarabunRegular.ttf";
import sarabunBold from "fonts/SarabunSemiBold.ttf";
import NotoSansLao from "fonts/NotoSansLaoSemiCondensedRegular.ttf";
import NotoSansLaoBold from "fonts/NotoSansLaoSemiCondensedBold.ttf";
import phetsarath from "../fonts/PhetsarathRegular.ttf";
import phetsarathBold from "../fonts/PhetsarathBold.ttf";
var formatTrackingDateTime = function(value) {
    if (!value) return "-";
    var date = moment.utc(value);
    return date.isValid() ? date.format("DD/MM/YYYY HH:mm") : "-";
};
var ReservationTrackingTimeline = function(param) {
    var data = param.data, isMobile = param.isMobile, language = param.language;
    var isLao = language === "la";
    var steps = [
        {
            label: isLao ? "ສົ່ງສິນຄ້າ" : "ส่งสินค้า",
            description: isLao ? "ສິນຄ້າຖືກຈັດສົ່ງແລ້ວ" : "สินค้าได้รับการจัดส่งแล้ว",
            date: data === null || data === void 0 ? void 0 : data.rs_reserve_approvedate,
            color: "#16a34a",
            icon: /*#__PURE__*/ _jsx(LocalShippingOutlinedIcon, {})
        },
        {
            label: isLao ? "ລໍຖ້າສົ່ງສິນຄ້າ" : "รอส่งสินค้า",
            description: isLao ? "ສິນຄ້າພ້ອມສຳລັບການຈັດສົ່ງ" : "สินค้าพร้อมสำหรับการจัดส่ง",
            date: data === null || data === void 0 ? void 0 : data.rs_reserve_waitdate,
            color: "#2563eb",
            icon: /*#__PURE__*/ _jsx(PendingActionsOutlinedIcon, {})
        },
        {
            label: isLao ? "ກວດສອບສິນຄ້າ" : "ตรวจสอบสินค้า",
            description: isLao ? "ສິນຄ້າຜ່ານການກວດສອບແລ້ວ" : "สินค้าผ่านการตรวจสอบแล้ว",
            date: data === null || data === void 0 ? void 0 : data.rs_reserve_pdcheckedate,
            color: "#7c3aed",
            icon: /*#__PURE__*/ _jsx(FactCheckOutlinedIcon, {})
        },
        {
            label: isLao ? "ກຳລັງຈັດສິນຄ້າ" : "กำลังจัดสินค้า",
            description: isLao ? "ກຳລັງກະກຽມສິນຄ້າເພື່ອຈັດສົ່ງ" : "กำลังเตรียมสินค้าเพื่อจัดส่ง",
            date: data === null || data === void 0 ? void 0 : data.rs_reserve_organizedate,
            color: "#9333ea",
            icon: /*#__PURE__*/ _jsx(Inventory2OutlinedIcon, {})
        },
        {
            label: isLao ? "ຢືນຢັນລາຍການ" : "ยืนยันรายการ",
            description: isLao ? "ພະນັກງານຂາຍຢືນຢັນລາຍການແລ້ວ" : "เซลล์ยืนยันรายการแล้ว",
            date: data === null || data === void 0 ? void 0 : data.rs_reserve_saledate,
            color: "#f59e0b",
            icon: /*#__PURE__*/ _jsx(HowToRegOutlinedIcon, {})
        },
        {
            label: isLao ? "ສົ່ງໃບຈອງ" : "ส่งใบจอง",
            description: isLao ? "ສ້າງແລະສົ່ງໃບຈອງສິນຄ້າແລ້ວ" : "สร้างและส่งใบจองสินค้าแล้ว",
            date: data === null || data === void 0 ? void 0 : data.rs_reserve_credate,
            color: "#f97316",
            icon: /*#__PURE__*/ _jsx(SendOutlinedIcon, {})
        }
    ];
    return /*#__PURE__*/ _jsx("div", {
        className: "card card-st-3 mt-2",
        style: {
            width: "100%",
            backgroundColor: "#fff"
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: "card-body",
            style: {
                padding: isMobile ? 16 : 28
            },
            children: steps.map(function(step, index) {
                var isCompleted = Boolean(step.date);
                var markerColor = isCompleted ? step.color : "#cbd5e1";
                return /*#__PURE__*/ _jsxs("div", {
                    style: {
                        position: "relative",
                        display: "grid",
                        gridTemplateColumns: isMobile ? "52px 1fr" : "70px 280px 1fr",
                        minHeight: isMobile ? 118 : 105
                    },
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            style: {
                                position: "relative",
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: [
                                index < steps.length - 1 ? /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        position: "absolute",
                                        top: 44,
                                        bottom: -2,
                                        width: 3,
                                        backgroundColor: isCompleted ? markerColor : "#e2e8f0"
                                    }
                                }) : null,
                                /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        width: 46,
                                        height: 46,
                                        borderRadius: "50%",
                                        border: "3px solid ".concat(markerColor),
                                        backgroundColor: "#fff",
                                        color: markerColor,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        zIndex: 1
                                    },
                                    children: /*#__PURE__*/ React.cloneElement(step.icon, {
                                        style: {
                                            fontSize: 25
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            style: {
                                padding: "7px 12px 0",
                                minWidth: 0
                            },
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        fontSize: isMobile ? 17 : 20,
                                        fontWeight: 700,
                                        color: isCompleted ? "#1f2937" : "#94a3b8"
                                    },
                                    children: step.label
                                }),
                                isMobile ? /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            style: {
                                                marginTop: 5,
                                                fontSize: 15,
                                                fontWeight: 600,
                                                color: isCompleted ? "#475569" : "#94a3b8"
                                            },
                                            children: formatTrackingDateTime(step.date)
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            style: {
                                                marginTop: 3,
                                                color: isCompleted ? "#64748b" : "#94a3b8"
                                            },
                                            children: step.description
                                        })
                                    ]
                                }) : null
                            ]
                        }),
                        !isMobile ? /*#__PURE__*/ _jsxs("div", {
                            style: {
                                paddingTop: 7
                            },
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        fontSize: 18,
                                        fontWeight: 600,
                                        color: isCompleted ? "#475569" : "#94a3b8"
                                    },
                                    children: formatTrackingDateTime(step.date)
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        marginTop: 5,
                                        fontSize: 16,
                                        color: isCompleted ? "#64748b" : "#94a3b8"
                                    },
                                    children: step.description
                                })
                            ]
                        }) : null
                    ]
                }, step.label);
            })
        })
    });
};
export function Reserver(param) {
    var _param_enableTracking = param.enableTracking, enableTracking = _param_enableTracking === void 0 ? false : _param_enableTracking;
    var _reserverData_shBranch, _reserverData_sysSaleid, _reserverData_sysSaleid1;
    var _$param = useParams();
    var reserverCode = useParams().reserverCode;
    // ตั้งค่า 2 ภาษา
    var _useTranslation = useTranslation(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var _useState = _sliced_to_array(useState(!localStorage.getItem("lang") ? "th" : localStorage.getItem("lang")), 2), language = _useState[0], setLanguage = _useState[1];
    var onClickLanguage = function() {
        if (language == "th") {
            setLanguage("la");
        } else {
            setLanguage("th");
        }
    };
    useEffect(function() {
        i18n.changeLanguage(language);
        localStorage.setItem("lang", language);
    }, [
        language
    ]);
    useEffect(function() {
        var savedLang = localStorage.getItem("lang");
        if (savedLang) i18n.changeLanguage(savedLang);
    }, [
        i18n
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState1 = _sliced_to_array(useState(""), 2), shopBranch = _useState1[0], setShopBranch = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), reserverData = _useState2[0], setReserverData = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), rowData = _useState3[0], setRowData = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), dataPrint = _useState4[0], setDataPrint = _useState4[1];
    var _useState5 = _sliced_to_array(useState("products"), 2), activeTab = _useState5[0], setActiveTab = _useState5[1];
    var schema = yup.object().shape({
        branchid: yup.string().required("")
    });
    var formatDDMMYYYY = function(value) {
        if (!value) return null;
        var d = new Date(value);
        if (isNaN(d.getTime())) return null; // กัน Invalid Date
        var pad = function(n) {
            return String(n).padStart(2, "0");
        };
        return "".concat(pad(d.getUTCDate()), "/").concat(pad(d.getUTCMonth() + 1), "/").concat(d.getUTCFullYear());
    };
    var myReserverReducer = useAppSelector(function(state) {
        return state.myReserverReducer;
    });
    useEffect(function() {
        if (reserverCode) {
            dispatch(myReserver({
                code: reserverCode
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        reserverCode
    ]);
    useEffect(function() {
        setIsLoading(myReserverReducer.isFetching);
        if (reserverCode) {
            if (myReserverReducer.data) {
                var _myReserverReducer_data_data, _myReserverReducer_data;
                setReserverData(myReserverReducer.data.data);
                var newData = [];
                if (Array.isArray((_myReserverReducer_data = myReserverReducer.data) === null || _myReserverReducer_data === void 0 ? void 0 : (_myReserverReducer_data_data = _myReserverReducer_data.data) === null || _myReserverReducer_data_data === void 0 ? void 0 : _myReserverReducer_data_data.rsCatalog)) {
                    newData = myReserverReducer.data.data.rsCatalog.map(function(catalog) {
                        var _catalog_rsDetail;
                        var _catalog_rsDetail_map;
                        return _object_spread_props(_object_spread({}, catalog), {
                            rsDetail: (_catalog_rsDetail_map = (_catalog_rsDetail = catalog.rsDetail) === null || _catalog_rsDetail === void 0 ? void 0 : _catalog_rsDetail.map(function(detail) {
                                return _object_spread_props(_object_spread({}, detail), {
                                    idDetail: nanoid()
                                });
                            })) !== null && _catalog_rsDetail_map !== void 0 ? _catalog_rsDetail_map : []
                        });
                    });
                }
                console.log("newData : ", newData);
                setRowData(newData);
            }
        }
    }, [
        myReserverReducer,
        reserverCode
    ]);
    var totalNet = rowData.reduce(function(sum, item) {
        return sum + Number(item.rs_catalog_net || 0);
    }, 0);
    var displayedProductRows = useMemo(function() {
        if (!enableTracking) return rowData;
        return rowData.map(function(catalog) {
            return _object_spread_props(_object_spread({}, catalog), {
                rsDetail: (catalog.rsDetail || []).filter(function(detail) {
                    return Number(detail.rs_detail_stamount || 0) > 0;
                })
            });
        }).filter(function(catalog) {
            return catalog.rsDetail.length > 0;
        });
    }, [
        enableTracking,
        rowData
    ]);
    var _reserverData_shBranch_sh_branch_code;
    var branchCode = String((_reserverData_shBranch_sh_branch_code = reserverData === null || reserverData === void 0 ? void 0 : (_reserverData_shBranch = reserverData.shBranch) === null || _reserverData_shBranch === void 0 ? void 0 : _reserverData_shBranch.sh_branch_code) !== null && _reserverData_shBranch_sh_branch_code !== void 0 ? _reserverData_shBranch_sh_branch_code : "").trim();
    var _reserverData_rs_reserve_branchname;
    var branchLabel = "".concat((_reserverData_rs_reserve_branchname = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_branchname) !== null && _reserverData_rs_reserve_branchname !== void 0 ? _reserverData_rs_reserve_branchname : "-").concat(enableTracking && branchCode ? " (".concat(branchCode, ")") : "");
    var documentTitle = enableTracking ? language === "la" ? "ໃບສົ່ງສິນຄ້າ" : "ใบส่งสินค้า" : t("Product Reservation Form");
    var _reserverData_rs_reserve_shopname, _reserverData_rs_reserve_contactname, _reserverData_rs_reserve_contactphone, _reserverData_rs_reserve_salename, _reserverData_sysSaleid_sys_user_phone, _reserverData_rs_reserve_suptactname, _reserverData_rs_reserve_suptactphone, _reserverData_rs_reserve_code, _reserverData_rs_reserve_code1, _reserverData_rs_reserve_shopname1, _reserverData_rs_reserve_contactname1, _reserverData_rs_reserve_contactphone1, _reserverData_rs_reserve_suptactname1, _reserverData_rs_reserve_suptactphone1, _reserverData_rs_reserve_salename1, _reserverData_sysSaleid_sys_user_phone1;
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: !isMobile ? "p-2" : "p-1",
            children: [
                /*#__PURE__*/ _jsxs(Stack, {
                    direction: "row",
                    justifyContent: "space-between",
                    className: "mb-1",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-24"
                        }),
                        /*#__PURE__*/ _jsxs(Tooltip, {
                            title: t("change language"),
                            onClick: function(e) {
                                return onClickLanguage();
                            },
                            children: [
                                /*#__PURE__*/ _jsx(LanguageIcon, {
                                    style: {
                                        fontSize: 30,
                                        cursor: "pointer"
                                    },
                                    className: "me-2"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    children: language == "th" ? "ภาษาไทย" : "ພາສາລາວ"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "pagezoom",
                    children: !isMobile ? /*#__PURE__*/ _jsx("div", {
                        className: "card card-st-3 mb-0",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card-body",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "pt-0",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "row gx-xl-0",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-12 col-sm-12 col-md-12 col-lg-6",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: "/images/pardesco-logo-new-black.png",
                                                style: {
                                                    width: 160
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-12 col-sm-12 col-md-12 col-lg-6 text-right",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "fs-24",
                                                children: documentTitle
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-12 mb-3"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-12 col-sm-12 col-md-12 col-lg-8",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "row gx-xl-0",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-xl-6 col-lg-12",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "fs-18",
                                                                children: [
                                                                    t("Customer"),
                                                                    " : ",
                                                                    (_reserverData_rs_reserve_shopname = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_shopname) !== null && _reserverData_rs_reserve_shopname !== void 0 ? _reserverData_rs_reserve_shopname : "-",
                                                                    " (",
                                                                    branchLabel,
                                                                    ")"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "fs-18",
                                                                children: [
                                                                    t("contact man 1"),
                                                                    " : ",
                                                                    (_reserverData_rs_reserve_contactname = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_contactname) !== null && _reserverData_rs_reserve_contactname !== void 0 ? _reserverData_rs_reserve_contactname : "-"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "fs-18",
                                                                children: [
                                                                    t("phone"),
                                                                    " : ",
                                                                    (_reserverData_rs_reserve_contactphone = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_contactphone) !== null && _reserverData_rs_reserve_contactphone !== void 0 ? _reserverData_rs_reserve_contactphone : "-"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-xl-6 col-lg-12",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "fs-18",
                                                                children: [
                                                                    t("caring sale"),
                                                                    " : ",
                                                                    (_reserverData_rs_reserve_salename = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_salename) !== null && _reserverData_rs_reserve_salename !== void 0 ? _reserverData_rs_reserve_salename : "-"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "fs-18",
                                                                children: [
                                                                    t("phone"),
                                                                    " : ",
                                                                    (_reserverData_sysSaleid_sys_user_phone = reserverData === null || reserverData === void 0 ? void 0 : (_reserverData_sysSaleid = reserverData.sysSaleid) === null || _reserverData_sysSaleid === void 0 ? void 0 : _reserverData_sysSaleid.sys_user_phone) !== null && _reserverData_sysSaleid_sys_user_phone !== void 0 ? _reserverData_sysSaleid_sys_user_phone : "-"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "fs-18",
                                                                children: [
                                                                    t("contact man 2"),
                                                                    " : ",
                                                                    (_reserverData_rs_reserve_suptactname = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_suptactname) !== null && _reserverData_rs_reserve_suptactname !== void 0 ? _reserverData_rs_reserve_suptactname : "-"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "fs-18",
                                                                children: [
                                                                    t("phone"),
                                                                    " : ",
                                                                    (_reserverData_rs_reserve_suptactphone = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_suptactphone) !== null && _reserverData_rs_reserve_suptactphone !== void 0 ? _reserverData_rs_reserve_suptactphone : "-"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-12 col-sm-12 col-md-12 col-lg-4",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "row gx-xl-0",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "col-xl-12 col-lg-12",
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "fs-18",
                                                            children: [
                                                                t("Document No"),
                                                                " : ",
                                                                (_reserverData_rs_reserve_code = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_code) !== null && _reserverData_rs_reserve_code !== void 0 ? _reserverData_rs_reserve_code : "-"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "fs-18",
                                                            children: [
                                                                t("issue date"),
                                                                " : ",
                                                                (reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_credate) ? formatDDMMYYYY(reserverData.rs_reserve_credate) : "-"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "fs-18",
                                                            children: [
                                                                t("Status"),
                                                                " : ",
                                                                (reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_status) == 1 && t("Signature") || (reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_status) == 2 && t("Confirmed") || (reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_status) == 3 && t("cancel") || "-"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }) : /*#__PURE__*/ _jsx("div", {
                        className: "card card-st-3 mb-0",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "card-body",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "pt-0",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "row gx-xl-0",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-12 col-sm-12 col-md-12 col-lg-6 text-center",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "fs-24",
                                                children: documentTitle
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-12 col-sm-12 col-md-12 col-lg-6 text-center",
                                            children: /*#__PURE__*/ _jsx("img", {
                                                src: "/images/pardesco-logo-new-black.png",
                                                style: {
                                                    width: 160,
                                                    margin: "auto"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "col-12 mb-3"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "col-12 col-sm-12 col-md-12 col-lg-8",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "fs-18",
                                                    children: [
                                                        t("Document No"),
                                                        " : ",
                                                        (_reserverData_rs_reserve_code1 = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_code) !== null && _reserverData_rs_reserve_code1 !== void 0 ? _reserverData_rs_reserve_code1 : "-"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "fs-18",
                                                    children: [
                                                        t("issue date"),
                                                        " : ",
                                                        (reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_credate) ? formatDDMMYYYY(reserverData.rs_reserve_credate) : "-"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "fs-18 mb-2",
                                                    children: [
                                                        t("Status"),
                                                        " : ",
                                                        (reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_status) == 1 && t("Signature") || (reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_status) == 2 && t("Confirmed") || (reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_status) == 3 && t("cancel") || "-"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "fs-18",
                                                    children: [
                                                        t("Customer"),
                                                        " : ",
                                                        (_reserverData_rs_reserve_shopname1 = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_shopname) !== null && _reserverData_rs_reserve_shopname1 !== void 0 ? _reserverData_rs_reserve_shopname1 : "-",
                                                        " (",
                                                        branchLabel,
                                                        ")"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "fs-18",
                                                    children: [
                                                        t("contact man 1"),
                                                        " : ",
                                                        (_reserverData_rs_reserve_contactname1 = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_contactname) !== null && _reserverData_rs_reserve_contactname1 !== void 0 ? _reserverData_rs_reserve_contactname1 : "-"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "fs-18",
                                                    children: [
                                                        t("phone"),
                                                        " : ",
                                                        (_reserverData_rs_reserve_contactphone1 = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_contactphone) !== null && _reserverData_rs_reserve_contactphone1 !== void 0 ? _reserverData_rs_reserve_contactphone1 : "-"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "fs-18",
                                                    children: [
                                                        t("contact man 2"),
                                                        " : ",
                                                        (_reserverData_rs_reserve_suptactname1 = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_suptactname) !== null && _reserverData_rs_reserve_suptactname1 !== void 0 ? _reserverData_rs_reserve_suptactname1 : "-"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "fs-18 mb-2",
                                                    children: [
                                                        t("phone"),
                                                        " : ",
                                                        (_reserverData_rs_reserve_suptactphone1 = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_suptactphone) !== null && _reserverData_rs_reserve_suptactphone1 !== void 0 ? _reserverData_rs_reserve_suptactphone1 : "-"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "fs-18",
                                                    children: [
                                                        t("caring sale"),
                                                        " : ",
                                                        (_reserverData_rs_reserve_salename1 = reserverData === null || reserverData === void 0 ? void 0 : reserverData.rs_reserve_salename) !== null && _reserverData_rs_reserve_salename1 !== void 0 ? _reserverData_rs_reserve_salename1 : "-"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "fs-18",
                                                    children: [
                                                        t("phone"),
                                                        " : ",
                                                        (_reserverData_sysSaleid_sys_user_phone1 = reserverData === null || reserverData === void 0 ? void 0 : (_reserverData_sysSaleid1 = reserverData.sysSaleid) === null || _reserverData_sysSaleid1 === void 0 ? void 0 : _reserverData_sysSaleid1.sys_user_phone) !== null && _reserverData_sysSaleid_sys_user_phone1 !== void 0 ? _reserverData_sysSaleid_sys_user_phone1 : "-"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }),
                enableTracking ? /*#__PURE__*/ _jsx("div", {
                    className: "d-flex mt-2",
                    style: {
                        width: "100%",
                        overflow: "hidden",
                        border: "1px solid #e5e7eb",
                        borderRadius: 10,
                        backgroundColor: "#fff"
                    },
                    children: [
                        {
                            value: "products",
                            label: language === "la" ? "ລາຍການສິນຄ້າ" : "รายการสินค้า"
                        },
                        {
                            value: "tracking",
                            label: language === "la" ? "ຕິດຕາມການຂົນສົ່ງ" : "ติดตามการขนส่ง"
                        }
                    ].map(function(tab) {
                        var isActive = activeTab === tab.value;
                        return /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            onClick: function() {
                                return setActiveTab(tab.value);
                            },
                            style: {
                                flex: 1,
                                minHeight: 52,
                                border: 0,
                                borderBottom: isActive ? "4px solid #b00412" : "4px solid transparent",
                                backgroundColor: "#fff",
                                color: isActive ? "#b00412" : "#64748b",
                                fontSize: isMobile ? 16 : 18,
                                fontWeight: isActive ? 700 : 500,
                                cursor: "pointer"
                            },
                            children: tab.label
                        }, tab.value);
                    })
                }) : null,
                !enableTracking || activeTab === "products" ? !isMobile ? // สำหรับ Desktop
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        height: "1000px",
                        overflowX: "auto",
                        overflowY: "scroll"
                    },
                    className: "table-scroll-x",
                    children: /*#__PURE__*/ _jsxs("table", {
                        className: "product-table",
                        children: [
                            /*#__PURE__*/ _jsx("thead", {
                                children: /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsx("th", {
                                            children: t("number")
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: t("product image")
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: t("product name")
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: t("barcode")
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: t("packaging size")
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: t("number of products")
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: t("Unit")
                                        })
                                    ]
                                })
                            }),
                            displayedProductRows.length > 0 && /*#__PURE__*/ _jsx("tbody", {
                                children: displayedProductRows.map(function(row, i) {
                                    return /*#__PURE__*/ _jsxs("tr", {
                                        style: {
                                            borderBottom: "1px solid #d2d2d2"
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: i + 1
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                width: "150",
                                                children: /*#__PURE__*/ _jsx("center", {
                                                    style: {
                                                        width: "150px"
                                                    },
                                                    children: row.rs_catalog_image ? /*#__PURE__*/ _jsx("img", {
                                                        src: row.rs_catalog_image,
                                                        alt: "สินค้า",
                                                        width: "150"
                                                    }) : ""
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: [
                                                    Number(row.rs_catalog_free) === 2 && /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-[6px] text-danger fs-12 text-left",
                                                        children: "ของแถม"
                                                    }),
                                                    Number(row.rs_catalog_tester) === 2 && /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-[6px] text-danger fs-12 text-left",
                                                        children: "สินค้าทดลอง"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-[10px] text-left",
                                                        children: language == "la" ? row.rs_catalog_namela : row.rs_catalog_name
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-[10px] tc-7 fs-12 text-left",
                                                        children: language == "la" ? row.rs_catalog_name : row.rs_catalog_namela
                                                    }),
                                                    row.rs_catalog_remark && /*#__PURE__*/ _jsxs("div", {
                                                        className: "mb-[6px] tc-7 fs-12 text-left",
                                                        children: [
                                                            "หมายเหตุ: ",
                                                            row.rs_catalog_remark
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: row.rsDetail.map(function(ele, index) {
                                                    var _ele_clDetail;
                                                    return /*#__PURE__*/ _jsx("div", {
                                                        className: "text-center mb-[22px]",
                                                        children: ((_ele_clDetail = ele.clDetail) === null || _ele_clDetail === void 0 ? void 0 : _ele_clDetail.cl_detail_showbarcode) == 1 ? ele.rs_detail_barcode : ""
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: row.rsDetail.map(function(ele, index) {
                                                    return /*#__PURE__*/ _jsxs("div", {
                                                        className: "text-left mb-[22px]",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                style: {
                                                                    float: "left",
                                                                    width: "40px"
                                                                },
                                                                children: language == "th" ? " ".concat(ele.setUnit.set_unit_name) : " ".concat(ele.setUnit.set_unit_namela)
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: "="
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "!bg-[#d9d9ded9] pl-2 pr-3 pt-2 pb-2 ml-2",
                                                                style: {
                                                                    borderRadius: 5
                                                                },
                                                                children: ele.rs_detail_ratio ? " ".concat(ele.rs_detail_ratio) : ""
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: ele.rs_detail_ratio ? " ".concat(t("item")) : ""
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: ele.rs_detail_ratiooption ? " / ".concat(ele.rs_detail_ratiooption, " ").concat(t("pack")) : ""
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: row.rsDetail.map(function(ele, index) {
                                                    return /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-[22px]",
                                                        children: NumberFormat(enableTracking ? ele.rs_detail_stamount : ele.rs_detail_amount, 0)
                                                    }, index);
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                style: {
                                                    padding: "8px"
                                                },
                                                children: row.rsDetail.map(function(ele, index) {
                                                    return /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-[22px]",
                                                        children: language == "th" ? " ".concat(ele.setUnit.set_unit_name) : " ".concat(ele.setUnit.set_unit_namela)
                                                    }, index);
                                                })
                                            })
                                        ]
                                    }, i);
                                })
                            }),
                            displayedProductRows.length == 0 && /*#__PURE__*/ _jsx("tbody", {
                                children: /*#__PURE__*/ _jsx("tr", {
                                    children: /*#__PURE__*/ _jsx("td", {
                                        colSpan: 9,
                                        className: "!bg-[#FFF]",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "py-5 my-5",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    class: "table-no-result mx-auto mb-4"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    class: "text-center fs-24 tc-13",
                                                    children: t("no list")
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                }) : // สำหรับ Mobile
                /*#__PURE__*/ _jsxs("div", {
                    className: "mt-2",
                    children: [
                        displayedProductRows.map(function(row, i) {
                            return /*#__PURE__*/ _jsxs("div", {
                                className: "relative mb-3 rounded-xl shadow-md border border-gray-200 overflow-hidden",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "absolute top-2 left-2 bg-red-500 text-white text-xs px-2 py-1 rounded-lg shadow",
                                        children: i + 1
                                    }),
                                    row.rs_catalog_image && /*#__PURE__*/ _jsx("img", {
                                        src: row.rs_catalog_image,
                                        alt: "สินค้า",
                                        className: "w-full h-40 object-contain bg-white"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "pt-1 pb-2 px-2",
                                        children: [
                                            Number(row.rs_catalog_free) === 2 && /*#__PURE__*/ _jsx("div", {
                                                className: "text-danger text-xs mb-1",
                                                children: "ของแถม"
                                            }),
                                            Number(row.rs_catalog_tester) === 2 && /*#__PURE__*/ _jsx("div", {
                                                className: "text-danger text-xs mb-1",
                                                children: "สินค้าทดลอง"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "font-semibold text-gray-800 text-sm mb-1",
                                                children: language == "la" ? row.rs_catalog_namela : row.rs_catalog_name
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-xs text-gray-500 mb-1",
                                                children: language == "la" ? row.rs_catalog_name : row.rs_catalog_namela
                                            }),
                                            row.rs_catalog_remark && /*#__PURE__*/ _jsxs("div", {
                                                className: "text-xs text-gray-500 mb-1",
                                                children: [
                                                    "หมายเหตุ: ",
                                                    row.rs_catalog_remark
                                                ]
                                            }),
                                            row.rsDetail.map(function(ele, index) {
                                                var _ele_clDetail;
                                                return /*#__PURE__*/ _jsx("div", {
                                                    className: "border-t py-1 text-xs",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex items-center justify-between mb-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("span", {
                                                                className: "text-gray-700",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "fw-bold me-3",
                                                                        children: ((_ele_clDetail = ele.clDetail) === null || _ele_clDetail === void 0 ? void 0 : _ele_clDetail.cl_detail_showbarcode) == 1 ? ele.rs_detail_barcode : ""
                                                                    }),
                                                                    language == "th" ? ele.setUnit.set_unit_name : ele.setUnit.set_unit_namela,
                                                                    ele.rs_detail_ratio && " = ".concat(ele.rs_detail_ratio, " ").concat(ele.rs_detail_ratio ? "  ".concat(t("item")) : "", " ").concat(ele.rs_detail_ratiooption ? " / ".concat(ele.rs_detail_ratiooption, " ").concat(t("pack")) : "")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsxs("span", {
                                                                className: "text-gray-700 fw-bold",
                                                                children: [
                                                                    NumberFormat(enableTracking ? ele.rs_detail_stamount : ele.rs_detail_amount, 0),
                                                                    " ",
                                                                    language == "th" ? ele.setUnit.set_unit_name : ele.setUnit.set_unit_namela
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, index);
                                            })
                                        ]
                                    })
                                ]
                            }, i);
                        }),
                        displayedProductRows.length == 0 && /*#__PURE__*/ _jsxs("div", {
                            className: "py-5 my-5",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "table-no-result mx-auto mb-4"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-24 tc-13",
                                    children: t("no list")
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ _jsx(ReservationTrackingTimeline, {
                    data: reserverData,
                    isMobile: isMobile,
                    language: language
                })
            ]
        })
    });
}
